import { Box, Skeleton, Typography } from '@mui/material'
import React from 'react'

import 'swiper/css'
import 'swiper/css/navigation'

const VodRowViewSkeleton = ({
    maxHeight,
    title,
    rows,
    items,
}: {
    maxHeight: number
    title?: string
    rows: number
    items: number
}) => {
    const categoryStyle = {
        color: 'white',
        fontSize: '25px',
        fontWeight: '500',
        marginBottom: '32px',
    }

    const rowViewContainerStyle = {
        position: 'relative',
        width: '99%',
    }

    const skeletonStyles = {
        bgcolor: 'grey.800',
        maxWidth: `${maxHeight * 0.83}px`,
        maxHeight: `${maxHeight}px`,
        width: '100vw',
        height: '100vh',
        mt: '46px',
        mb: '20px',
        ml: '20px',
    }

    return (
        <Box sx={rowViewContainerStyle}>
            {title && <Typography sx={categoryStyle}>{title}</Typography>}

            {[...Array(rows).keys()].map((index) => (
                <Box key={index} display="flex" mr="20px">
                    {[...Array(items).keys()].map((index) => (
                        <Skeleton
                            sx={skeletonStyles}
                            key={index}
                            animation="wave"
                            variant="rectangular"
                        />
                    ))}
                </Box>
            ))}
        </Box>
    )
}

export { VodRowViewSkeleton }
